import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import styles from "./style.module.scss";
import { MDBAnimation } from "mdbreact";
import DownLoadApppMobile from "./../../molecules/SlideApplication";
import cx from "classnames";
const UtilitiesTwo = props => {
  return (
    <MDBAnimation className={cx(styles.utilities_two, styles.mobile)}>
      <MDBContainer>
        <MDBRow>
          <MDBCol size="12">
            <div className={styles.utilities_item}>
              <DownLoadApppMobile />
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBAnimation>
  );
};

export default UtilitiesTwo;
